import React, { useRef, useState }      from 'react';
import { Modal, Form, Button }          from 'react-bootstrap';
import { useDispatch }                  from 'react-redux';
import { Formik }                       from 'formik';
import moment                           from 'moment';
import * as yup                         from 'yup';

import { ICON_SAVE, ICON_CANCEL }       from '../../../extras/icons';
import binaries                         from '../../../../data/binaryData';
import ButtonSpinner                    from '../../../layout/ButtonSpinner'
import clienteAxios                     from '../../../../config/axios';

import { agendateIntAudiencesAction }   from '../../../../actions/audiencesActions';
import { ErrorMessage }                 from '../../../extras/toastMessages';
import { JUDGE_INTERVEENING }           from '../../../../constants/agendateTypes';
import { MSG_ERROR_SERVER }             from '../../../../constants/messages';





const JudgeIntForm = props => {


    // ------------------------------------------------------------------------------------------------------
    // DECLARACIONES ----------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    // Tomo los props
    const { show, handleClose, audience, judge } = props;
    
    // Inicializo el dispatch
    const dispatch = useDispatch();
    
    // Genero los ref
    const refFecha = useRef();
    
    // Inicializo datos
    const initialData = {
        fecha: '',
        inicio: '',
        fin: '',
        sala: '',
        operador: '',
        enviarEnlace: 1,
        observacion: ''
    }

    // Inicializo el state local
    const [loading, setLoading] = useState(false);
    const [operators, setOperators] = useState([]);
    const [rooms, setRooms] = useState([]);



    // ------------------------------------------------------------------------------------------------------
    // FUNCIONES --------------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    // Manejo cuando se muestra
    const handleOnShow = e => {
        //Cargo los parámetros
        loadParameters();
        //Pongo el foco en el primer campo
        refFecha.current.focus();
    }

    // Función que maneja los parámetros
    const loadParameters = async () => {
        try
        {   //Cargo la espera
            setLoading(true);
            //Salas
            const responseRooms = await clienteAxios.get(`/sala?search=activo:1&sort=descripcion:asc`);
            //Seteo los datos
            setRooms(responseRooms.data.content);
            //Operadores
            const responseOperators = await clienteAxios.get(`/usuario?search=perfil.id:2,nivel.id:3,activo:1&sort=apellido:asc,nombre:asc`);
            //Seteo los datos
            setOperators(responseOperators.data.content);
            //Oculto la espera
            setLoading(false);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Oculto la espera
            setLoading(false);
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }

    // Manejo el guardado
    const handleSave = async values => {
        //Armo los datos
        const data = {
            inicio: `${values.fecha} ${values.inicio}:00`,
            fin: `${values.fecha} ${values.fin}:00`,
            salaId: values.sala,
            observacion_agendamiento: values.observacion,
            operadorId: values.operador,
            jueces: [{
                id: judge.id
            }],
            enviarEnlace: values.enviarEnlace
        }
        //Llamo al dispatch
        dispatch( agendateIntAudiencesAction(audience, data, handleClose, JUDGE_INTERVEENING) );
    }

    // Esquema de validación
    const validationSchema = yup.object({
        fecha: yup.date().required(),
        inicio: yup.string().required(),
        fin: yup.string().required(),
        sala: yup.number().required(),
        operador: yup.number().required(),
        enviarEnlace: yup.number().required()
    });



    // ------------------------------------------------------------------------------------------------------
    // RENDERIZO --------------------------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------------

    return (
        <Modal
            show = { show }
            onHide = { handleClose } 
            onShow = { handleOnShow } 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            size = "lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <strong>Agendar Juez Interviniente</strong> <small>(Audiencia #{ audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema = { validationSchema }
                initialValues = {{ ...initialData }}
                onSubmit = { values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        A continuación complete los campos para generar el Agendamiento
                                    </div>
                                </div>
                                <div className="col-12">
                                    Fecha Solicitud: <strong>{ audience.fechaSolicitud ? moment(audience.fechaSolicitud).format('DD/MM/YYYY HH:mm') : '' }</strong>
                                    <hr/>
                                    Juez seleccionado: { judge && `${judge.apellido}, ${judge.nombre}`}
                                </div>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="fecha">Fecha</label>
                                    <Form.Control
                                        id = "fecha"
                                        className = "form-control" 
                                        autoFocus 
                                        name = "fecha" 
                                        type = "date" 
                                        placeholder = "Ingrese Fecha"
                                        value = { values.fecha }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.fecha }
                                        disabled = { loading }
                                        ref = { refFecha }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fecha }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="inicio">Hora inicio</label>
                                    <Form.Control
                                        id = "inicio"
                                        className = "form-control" 
                                        name = "inicio" 
                                        type = "time" 
                                        placeholder = "Hora inicio"
                                        value = { values.inicio }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.inicio }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.inicio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="fin">Hora fin</label>
                                    <Form.Control
                                        id = "fin"
                                        className = "form-control" 
                                        name = "fin" 
                                        type = "time" 
                                        placeholder = "Hora fin"
                                        value = { values.fin }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.fin }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fin }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="sala">Sala</label>
                                    <Form.Control
                                        as = "select"
                                        id = "sala"
                                        className = "form-control"  
                                        name = "sala" 
                                        value = { values.sala }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.sala }
                                        disabled = { loading }
                                    >
                                        <option value="">Seleccione...</option>
                                        {   rooms.map(room => (
                                                <option value={room.id} key={`mfr${room.id}`}>
                                                    { room.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.sala }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="operador">Operador</label>
                                    <Form.Control
                                        as = "select"
                                        id = "operador"
                                        className = "form-control"  
                                        name = "operador" 
                                        value = { values.operador }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.operador }
                                        disabled = { loading }
                                    >
                                        <option value="">Seleccione...</option>
                                        {   operators.map(operator => (
                                                <option value={operator.id} key={`mfo${operator.id}`}>
                                                    { operator.apellido + ', ' + operator.nombre }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.operador }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="enviarEnlace">¿Enviar enlace de acceso a la audiencia remota?</label>
                                    <Form.Control
                                        as = "select"
                                        id = "enviarEnlace"
                                        className = "form-control"  
                                        name = "enviarEnlace" 
                                        value = { values.enviarEnlace }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.enviarEnlace }
                                        disabled = { loading }
                                    >
                                        <option value="1">SI</option>
                                        <option value="0">NO</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Debe seleccionar si se enviará el enlace
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12">
                                    <label htmlFor="observacion">Observaciones</label>
                                    <Form.Control
                                        id = "observacion"
                                        className = "form-control" 
                                        name = "observacion" 
                                        as = "textarea" 
                                        rows = { 4 }
                                        placeholder = "Observaciones para generar el Agendamiento"
                                        value = { values.observacion }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.observacion }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.observacion }
                                    </Form.Control.Feedback>
                                </Form.Group>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>AGENDAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default JudgeIntForm;
